const FALLBACK_MARKETS = '/prompted-portfolio-static/data/snapshots/coingecko_ai_markets.json'
const FALLBACK_CATEGORY = '/prompted-portfolio-static/data/snapshots/coingecko_ai_category.json'

const marketEndpoint = 'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&category=artificial-intelligence&order=market_cap_desc&per_page=15&page=1&sparkline=false&price_change_percentage=24h%2C7d%2C30d'
const categoryEndpoint = 'https://api.coingecko.com/api/v3/coins/categories/artificial-intelligence'

const fetchJson = async (url) => {
  const response = await fetch(url, { headers: { accept: 'application/json' }, signal: AbortSignal.timeout(4500) })
  if (!response.ok) throw new Error(`${response.status} from ${url}`)
  return response.json()
}

const normalize = (markets, category, mode, note = '') => ({
  rows: Array.isArray(markets) ? markets.filter((row) => row?.market_cap > 0) : [],
  category: category || {},
  mode,
  note,
  updatedAt: category?.updated_at || markets?.[0]?.last_updated || null,
})

export async function loadAiMarket() {
  const vpsBase = import.meta.env.VITE_PROMPTED_PORTFOLIO_DATA_URL?.replace(/\/$/, '')

  if (vpsBase) {
    try {
      const [markets, category] = await Promise.all([
        fetchJson(`${vpsBase}/market/coingecko_ai_markets.json`),
        fetchJson(`${vpsBase}/market/coingecko_ai_category.json`),
      ])
      return normalize(markets, category, 'VPS live')
    } catch (error) {
      // Continue to a verified public source and then the dated snapshot.
    }
  }

  try {
    const [markets, category] = await Promise.all([
      fetchJson(marketEndpoint),
      fetchJson(categoryEndpoint),
    ])
    return normalize(markets, category, 'Public live')
  } catch (error) {
    const [markets, category] = await Promise.all([
      fetchJson(FALLBACK_MARKETS),
      fetchJson(FALLBACK_CATEGORY),
    ])
    return normalize(markets, category, 'Dated snapshot', 'Live request failed. Showing the bundled, source-stamped snapshot.')
  }
}
